import { ethers } from "ethers";
import { Magic } from "magic-sdk";
import Web3 from "web3";

import {
  HederaSessionEvent,
  HederaJsonRpcMethod,
  DAppConnector,
  HederaChainId,
} from '@hashgraph/hedera-wallet-connect'
import { LedgerId } from '@hashgraph/sdk'

const projectId:any = process.env.REACT_APP_HASHPACK_PROJECT_ID;

const metadata = {
  name: 'vyga',
  description: 'vyga description',
  url: process.env.REACT_APP_HASHPACK_URL ?? "",
  icons: [process.env.REACT_APP_HASHPACK_ICON_URL ?? ""],
};

let dAppConnector:any;

// Session handling function
const handleNewSession = async(session:any) => {
  console.log('handleNewSession', session);
  const sessionAccount = session.namespaces?.hedera?.accounts?.[0]
  const sessionParts = sessionAccount?.split(':')
  const accountId = sessionParts.pop()
  const network = sessionParts.pop()

  if (!accountId) {
    return null
  } else {
    localStorage.setItem('hederaAccountId', accountId)
    localStorage.setItem('hederaNetwork', network)
    console.log('sessionAccount is', accountId, network)
    const hashpackData = {
      walletAddress: accountId,
      networkId: network
    }
    return hashpackData;
  }
}

// Initialize and set up event listeners
 const initializeWalletConnect = async() => {
  dAppConnector = new DAppConnector(
    metadata,
    // LedgerId.MAINNET,
    LedgerId.TESTNET,
    projectId,
    Object.values(HederaJsonRpcMethod),
    [HederaSessionEvent.ChainChanged, HederaSessionEvent.AccountsChanged],
    [HederaChainId.Testnet],
  )
  await dAppConnector.init({ logger: 'error' })

  dAppConnector.onSessionIframeCreated = (session:any) => {
    handleNewSession(session)
  }
}

// Connect wallet function
 const connectWallet = async() => {
  const session = await dAppConnector.openModal()
  const sessionRes = handleNewSession(session);
  return sessionRes;
}

export const connectHashPack = async () => {
  try {
    
    await initializeWalletConnect()

    // Connect wallet when needed
    const hashpackResponnse = await connectWallet()
    console.log('hashpackResponnse',hashpackResponnse);

    return hashpackResponnse;



  } catch (error: any) {
    console.log("Error during HashConnect initialization:", error);

    if (error instanceof Error) {
      // Specific error message when pairing is canceled manually
      if (error.message.includes("closed the HashConnect pairing modal")) {
        throw new Error("User manually closed the HashConnect pairing modal");
      }
      // For other types of errors
      throw new Error("Failed to initialize HashConnect");
    }

    // General fallback for any unknown errors
    throw new Error("Unknown error occurred during HashConnect connection");
  }
};


// ----------------- Metamask --------------------
export const connectMetaMaskWallet = async () => {
  const providers = (window.ethereum as any)?.providers || [window.ethereum];

  // Find MetaMask provider
  const metaMaskProvider = providers.find(
    (provider: any) =>
      provider && provider.isMetaMask && !provider.overrideIsMetaMask
  );

  // Fall back to window.ethereum if no providers are found (for Safari)
  const selectedProvider =
    metaMaskProvider ||
    ((window.ethereum as any)?.isMetaMask ? window.ethereum : null);

  if (!selectedProvider) {
    throw new Error("MetaMask is not installed");
  }

  // if (!metaMaskProvider) {
  //   // alert("MetaMask is not installed!");
  //   // return;
  //   console.log("MetaMask is not installed!");
  //   throw new Error("MetaMask is not installed");
  // }

  const web3 = new Web3(metaMaskProvider);
  try {
    // Request account access
    await metaMaskProvider.request({ method: "eth_requestAccounts" });
    const accounts = await web3.eth.getAccounts();
    console.log("MetaMask Wallet connected!");

    // Get network ID
    const networkId = await web3.eth.net.getId();
    console.log("Network ID:", typeof networkId); // bigint

    return { account: accounts[0], networkId: networkId.toString() };
  } catch (error: any) {
    console.error("MetaMask connection failed:", error);
    // alert("Failed to connect MetaMask wallet");
    if (error.code === 4001) {
      // User rejected the request
      throw new Error("User rejected the connection");
    }
    // General connection failure
    throw new Error("Failed to connect MetaMask wallet");
  }
};

// ----------------- Coinbase -----------------
export const connectCoinbaseWallet = async () => {
  const providers = (window.ethereum as any)?.providers || [window.ethereum];

  // Find Coinbase Wallet provider
  const coinbaseProvider = providers.find(
    (provider: any) =>
      provider && (provider.isCoinbaseWallet || provider.overrideIsMetaMask)
  );

  // Fall back to window.ethereum if no providers are found (for Safari)
  const selectedProvider =
    coinbaseProvider ||
    ((window.ethereum as any)?.isCoinbaseWallet ? window.ethereum : null);

  if (!selectedProvider) {
    throw new Error("Coinbase is not installed");
  }

  // if (!coinbaseProvider) {
  //   throw new Error("Coinbase is not installed");
  // }

  const web3Provider = new ethers.providers.Web3Provider(coinbaseProvider);
  try {
    // Request account access
    await coinbaseProvider.request({ method: "eth_requestAccounts" });
    const accounts = await web3Provider.listAccounts();
    console.log("Coinbase Wallet connected!");

    // Get network ID
    const network = await web3Provider.getNetwork();
    console.log("Network ID:", network.chainId);

    return { address: accounts[0], networkId: network.chainId };
  } catch (error: any) {
    console.error("Coinbase connection failed:", error);
    if (error.code === 4001) {
      // User rejected the request
      throw new Error("User rejected the connection");
    }
    // General connection failure
    throw new Error("Failed to connect Coinbase wallet");
  }
};

// ------------------ Magic link -----------------
export const connectMagicLink = async (email: string) => {
  try {
    const magic = new Magic(process.env.REACT_APP_MAGIC_PUBIC_KEY || ""); // Replace with your Magic public key
    // const email = prompt("Enter your email for Magic Link authentication:");
    if (!email) return;

    await magic.auth.loginWithMagicLink({ email });
    const userMetadata = await magic.user.getMetadata();

    // Get network ID
    const networkId = await magic.rpcProvider.request({
      method: "net_version",
    });
    console.log("Network ID:", networkId);

    return { userMetadata, networkId };
    // setWalletAddress(userMetadata.email || "");
  } catch (err: any) {
    if (err.code === -32603) {
      // User rejected the request
      throw new Error("User rejected the connection");
    }
    console.log("Error connecting to Magic Link:", err, err.code === -32603);
    throw new Error("Failed to connect MagicLink");
  }
};